import React from 'react'
import { Button as MuiButton } from '@mui/material'
import { ButtonProps } from '@mui/material/Button/Button'

const Button: React.FC<ButtonProps> = ({ children, ...props }) => {
	const { variant = 'contained', ...otherProps } = props

	return (
		<MuiButton variant={variant} {...otherProps}>
			{children}
		</MuiButton>
	)
}

Button.displayName = 'Button'

export { Button }
